import { Button, Divider, Typography } from "@material-ui/core";
import { Add } from "@material-ui/icons";
import clsx from "clsx";
import { LoyaltyInfoFormComponentProps, TravelerSelectDropdown } from "halifax";
import React, { Fragment, useEffect, useState } from "react";
import { ParentState, useChildMachineState } from "@capone/checkout";

import {
  ICorpPerson,
  IFlyerOption,
  IPerson,
  ITravelerStepErrors,
  TripDetails,
} from "redmond";
import { FrequentFlyerForm } from "../FrequentFlyerForm";
import "./styles.scss";
import { getFrequentFlyerProgramFromTrip } from "./utils";
import { Event, TEvent } from "../../../state/events";
import { PackagesMachineContext } from "../../../state/types";
// import { getIsLapInfant } from "../../FlightBookPassengerSelection/useFlightBookPassengerSelect";

export interface FlightTravelerSelectDropdownFormProps {
  className?: string;
  loading: boolean;
  travelers: IPerson[];
  disableEditTravelerInfo: boolean;
  selectedTravelerIds: string[];
  showErrors: ITravelerStepErrors;
  tripDetails?: TripDetails;
  setShowErrors: (showErrors: ITravelerStepErrors) => void;
  updateSelectedTraveler: (traveler: ICorpPerson | IPerson) => void;
  removeSelectedTraveler: (traveler: ICorpPerson | IPerson) => void;
  updateUserPassenger: (passenger: IPerson, isNewTraveler: boolean) => void;
  selectedTravelersList: Array<IPerson>;
}

const getRenderLoyaltyComponent =
  (frequentFlyerPrograms: IFlyerOption[]) =>
  ({ onChange, disabled, traveler }: LoyaltyInfoFormComponentProps) =>
    (
      <FrequentFlyerForm
        onChange={(flyerMap) => onChange(undefined, flyerMap)}
        disabled={disabled}
        traveler={traveler}
        frequentFlyerPrograms={frequentFlyerPrograms}
      />
    );

export const FlightTravelerSelectDropdownForm = ({
  className,
  loading,
  travelers,
  disableEditTravelerInfo,
  selectedTravelerIds,
  showErrors,
  setShowErrors,
  tripDetails,
  updateSelectedTraveler,
  removeSelectedTraveler,
  updateUserPassenger,
  selectedTravelersList,
}: FlightTravelerSelectDropdownFormProps) => {
  const [dropdownCount, setDropdownCount] = useState(
    selectedTravelerIds.length || 1
  );

  const [, passengerChildMachineSend] = useChildMachineState<
    TEvent,
    PackagesMachineContext
  >(ParentState.passengerInformation);

  useEffect(() => {
    if (disableEditTravelerInfo) {
      setDropdownCount(selectedTravelerIds.length);
    }
  }, [disableEditTravelerInfo]);

  const frequentFlyerPrograms = tripDetails
    ? getFrequentFlyerProgramFromTrip(tripDetails)
    : null;

  return (
    <div className={clsx("traveler-select-dropdown-container", className)}>
      <div className="form-container">
        <Typography variant="h3" className="title">
          Select or add travelers
        </Typography>
        <Typography variant="body2" component="p" color="textPrimary">
          Select or add travelers for this flight booking.
        </Typography>
        {[...Array(dropdownCount)].map((_, index) => (
          <Fragment key={index}>
            {index > 0 && <Divider style={{ margin: "20px 0" }} />}
            <TravelerSelectDropdown
              travelers={travelers}
              setProgress={() => {}}
              disableEditTravelerInfo={disableEditTravelerInfo}
              selectedTravelers={selectedTravelersList}
              updateSelectedTraveler={updateSelectedTraveler}
              removeSelectedTraveler={(traveler) => {
                removeSelectedTraveler(traveler);
                passengerChildMachineSend({
                  type: Event.SET_USER_SELECTED_TRAVELERS_LIST,
                  userSelectedTravelersList: selectedTravelersList.filter(
                    (t) => t.id !== traveler.id
                  ),
                });
                setDropdownCount((prevCount) =>
                  prevCount === 1 ? 1 : prevCount - 1
                );
              }}
              index={index}
              updateUserPassenger={(payload, isNewTraveler) => {
                updateUserPassenger(payload.person, isNewTraveler ?? false);
              }}
              showErrors={showErrors}
              setShowErrors={setShowErrors}
              loyaltyProgram={null}
              loading={loading}
              renderLoyaltyComponent={
                frequentFlyerPrograms !== null
                  ? getRenderLoyaltyComponent(frequentFlyerPrograms)
                  : undefined
              }
              productType="flight"
            />
          </Fragment>
        ))}

        <Button
          variant="outlined"
          color="secondary"
          className="add-traveler-button"
          startIcon={<Add />}
          disabled={
            dropdownCount > Object.keys(selectedTravelersList).length ||
            disableEditTravelerInfo
          }
          onClick={() => setDropdownCount((prevCount) => prevCount + 1)}
        >
          Add additional traveler
        </Button>
      </div>
    </div>
  );
};
